<div class="sub-component-container" *ngIf="subReference">
  <div class="sub-title">{{"sub-reference-title" | translate}}</div>
  <div class="sub-content-container">
    <app-input [disabled]="readOnlyMode" [(value)]="subReference.supplierReferenceNumber"
      [name]="'sub-reference-number' | translate"
      [maxTextLength]="100"></app-input>
  </div>
</div>
